import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const BarChart = () => {

  const chartData = [
    {
      name: "PRODUCT A",
      data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
      color: "#d5549f",
    },
    {
      name: "PRODUCT B",
      data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
      color: "#5068ef",
    },
    {
      name: "PRODUCT C",
      data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
      color: "#e6dce1",
    },
  ];

  const chartOptions = {
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        backgroundColor: "#000000"
      },
      theme: 'dark',
      onDatasetHover: {
        style: {
          fontSize: "12px",
        },
      },
    },
    xaxis: {
      categories: ["17", "18", "19", "20", "21", "22", "23", "24", "25"],
      labels: {
        show: true,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
    },
    grid: {
      borderColor: "rgba(163, 174, 208, 0.3)",
      show: true,
      yaxis: {
        lines: {
          show: false,
        },
      },
      row: {
        opacity: 0.5,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      type: "solid",
      colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
    },
    legend: {
      show: false,
    },
    colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "20px",
      },
    },
  };

  const [data, setData] = useState(chartData);
  const [options, setOptions] = useState(chartOptions);

  useEffect(() => {
    setData(chartData);
    setOptions(chartOptions);
  }, []);

  return (
    <Chart
    // className="text-[#e6dce1]"
      options={options}
      series={data}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default BarChart;